export const fontSize01 = '12px';
export const fontSize02 = '14px';
export const fontSize03 = '16px';
export const fontSize04 = '18px';
export const fontSize05 = '20px';
export const fontSize06 = '24px';
export const fontSize07 = '30px';
export const fontSize08 = '36px';
export const fontSize09 = '48px';
export const fontSize10 = '60px';
export const fontSize11 = '72px';

export const fontFamily = `'BrandonTextWeb-Regular', sans-serif`;

export const fontWeightLight = 300;
export const fontWeightMedium = 500;
export const fontWeightBold = 700;
